(function(){ "use strict";}());


angular.module("app")
    .controller("FactsController",
    ["$scope", "$q" ,"AppService","$rootScope", function($scope, $q, AppService,$rootScope){

        var trace = angular.trace;
        $scope.maxAttempts = 0;
        $scope.totalPoints = 0;
        $scope.statements = null;
        $scope.potentialFactAnswers = [];
        $scope.potentialFictionAnswers = [];
        $scope.points = 0;
        $scope.attempts = 0;

        $scope.$watch("currentMinigame",onMinigameSelection);

        $scope.fact = function(){
            if($scope.currentStatement.fact) {
                var answer = getNextAnswer("Fact");
                answer.filled = true;
                answer.item = $scope.currentStatement;
                $scope.currentStatement = {description:$scope.currentStatement.correct,feedback:true};
                $scope.points ++;
                $scope.setActiveAnswer(answer,"Fact");
                $scope.updatePoints($scope.points);
                $rootScope.$emit("audio","Correct_Location");
            }
            else{
                $scope.currentStatement = {description:$scope.currentStatement.response,feedback:true};
                $scope.attempts ++;
                $scope.updateTelepathy($scope.attempts);
                $rootScope.$emit("audio","Losing_Psychic_Power");
            }
        };

        $scope.fiction = function(){
            if(!$scope.currentStatement.fact){
                 var answer = getNextAnswer("Fiction");
                 answer.filled = true;
                 answer.item = $scope.currentStatement;
                 $scope.currentStatement = {description:$scope.currentStatement.correct,feedback:true};
                 $scope.points ++;
                 $scope.setActiveAnswer(answer,"Fiction");
                 $scope.updatePoints($scope.points);
                 $rootScope.$emit("audio","Correct_Location");
                 
            }
            else{
                $scope.currentStatement = {description:$scope.currentStatement.response,feedback:true};
                $scope.attempts ++;
                $scope.updateTelepathy($scope.attempts);
                $rootScope.$emit("audio","Losing_Psychic_Power");
            }
        };

        $scope.onContinue = function(){
            var complete = checkComplete();
            if(complete === true) 
            {
                $rootScope.$emit("audio","Win_Game");
                return $scope.setGeocacheCallback(win);
            }
            else if(complete === false) return lose();

            setCurrentStatement(true);
        };

        $scope.setActiveAnswer = function(item,type){
            if(!item.item) return;
            resetAnswers(type);
            item.active = true;
            $scope["active"+type] = item;
        };

        function resetAnswers(type){
            var source = $scope["potential"+type+"Answers"];
            for(var i = 0, count = source.length; i < count; i++){
                var item = source[i];
                item.active = false;
            }
            return null;
        }

        function checkComplete(){
            if($scope.points === $scope.totalPoints) return true;
            else if($scope.attempts === $scope.maxAttempts) return false;
            return null;
        }
        function win(){
            var deferred = $q.defer();
            var resetCallback;
            deferred.promise.then(returnToMainMenu);

            $scope.currentLocation.isCorrect = true;
            $scope.setCurrentArtifact($scope.currentLocation.artifact,deferred);
            var evt = {
                eventCategory: "GRTT: Mini Game",
                eventLabel:  "GRTT: " + $scope.currentMinigame.title
            };
            gtag("event", "GRTT: end - complete", evt);
        }
        function lose(){
            var deferred = $q.defer();
            var resetCallback;
            deferred.promise.then(returnToMainMenu);

            var evt = {
                eventCategory: "GRTT: Mini Game",
                eventLabel:  "GRTT: " + $scope.currentMinigame.title
            };
            gtag("event", "GRTT: end - incomplete", evt);

            
            $rootScope.$emit("audio","Lose_Game");
            $scope.drawDownHours(4);
            $scope.currentLocation.isCorrect = false;
            if($scope.hoursRemaining >= 4){
              resetCallback = $q.defer();
              resetCallback.promise.then(reset);
            }
            $scope.setCurrentFeedback("current feedback object", deferred, resetCallback);
        }

        function returnToMainMenu(){
            $scope.setCurrentPage($scope.currentLocation.isCorrect ? $scope.PAGE_ARTIFACT_COLLECTION : $scope.PAGE_MAP);
        }

        function getNextAnswer(type){
            var source = $scope["potential"+type+"Answers"];
            for(var i = 0, count = source.length; i < count; i++){
                var item = source[i];
                if(!item.filled) return item;
            }
            return null;
        }

       

        function onMinigameSelection(value){
            if(!value) return;
            if(value.type !== "fact-opinion") return;
            reset(value);
        }

        function reset(value){
            if(!$rootScope.FactHelpView){
                $rootScope.FactHelpView = true;
                $scope.help();
            }
            
            if(!value) value = $scope.currentMinigame;
            $scope.maxAttempts = value.maxAttempts;
            $scope.totalPoints = value.points;
            $scope.statements = value.items.concat();
            $scope.potentialFactAnswers = [];
            $scope.potentialFictionAnswers = [];
            $scope.attempts = 0;
            $scope.points = 0;
            $scope.updateTelepathy(0);
            $scope.updatePoints(0);
            $scope.activeFact = $scope.activeFiction = null;
            randomize();

            var potential = value.items.length;
            for(var i = 0; i < potential; i++){
                $scope.potentialFactAnswers.push({active:false,full:false,link:null});
                $scope.potentialFictionAnswers.push({active:false,full:false,link:null});
            }
            setCurrentStatement();

            var evt = {
              eventCategory: "GRTT: Mini Game",
              eventLabel:  "GRTT: " + $scope.currentMinigame.title
            };
            gtag("event", "GRTT: start", evt);
        }

        function setCurrentStatement(playSound){
            $scope.currentStatement = $scope.statements.shift();
            if(playSound) $rootScope.$emit("audio","Speech_Bubble");
        }

        function randomize(){
            for(var i = 0, count = $scope.statements.length; i < count; i++){
                var statement = $scope.statements[i];
                statement.index = Math.random();
            }
            $scope.statements.sort(randomSort);
        }
        function randomSort(a,b){
            if(a.index > b.index) return 1;
            if(a.index < b.index) return -1;
            return 0;
        }
    }]);
